export default __webpack_public_path__ + "static/media/mnav-l.a49ac39a.svg";